import { motion, useInView } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';

import { COMPETITOR_RED, EASE_OUT, MUTED_GRAY, NOPING_GREEN, PROOF_BARS } from '../constants';

const CONTAINER_H = 200;

export function ProofBars() {
  const { t } = useTranslation('components/trial/lp/v1c');
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <div ref={ref} className='mx-auto grid max-w-4xl grid-cols-2 gap-6 sm:grid-cols-4 md:gap-8'>
      {PROOF_BARS.map((bar, i) => {
        const maxVal = Math.max(bar.before, bar.after) * 1.15;
        const beforePx = Math.max(Math.round((bar.before / maxVal) * CONTAINER_H), 10);
        const afterPx = bar.label === 'proof_packet_loss' ? 8 : Math.max(Math.round((bar.after / maxVal) * CONTAINER_H), 10);

        return (
          <motion.div key={bar.label} className='text-center' initial={{ opacity: 0, y: 40 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: i * 0.1, ease: EASE_OUT as unknown as [number, number, number, number] }}>
            <p className='mb-4 text-xs font-semibold uppercase tracking-widest' style={{ color: MUTED_GRAY }}>
              {t(bar.label)}
            </p>

            <div className='mb-3 flex items-end justify-center gap-4' style={{ height: CONTAINER_H }}>
              <motion.div className='w-12 rounded-t-lg md:w-14' style={{ background: `linear-gradient(180deg, ${COMPETITOR_RED} 0%, ${COMPETITOR_RED}90 100%)`, opacity: 0.85 }} initial={{ height: 0 }} animate={inView ? { height: beforePx } : {}} transition={{ duration: 1, delay: 0.2 + i * 0.15, ease: [0.34, 1.56, 0.64, 1] }} />

              <motion.div className='w-12 rounded-t-lg md:w-14' style={{ background: `linear-gradient(180deg, ${NOPING_GREEN} 0%, #6BCC00 100%)`, boxShadow: `0 0 12px ${NOPING_GREEN}30` }} initial={{ height: 0 }} animate={inView ? { height: afterPx } : {}} transition={{ duration: 1, delay: 0.4 + i * 0.15, ease: [0.34, 1.56, 0.64, 1] }} />
            </div>

            <motion.div className='flex items-center justify-center gap-3 text-sm' initial={{ opacity: 0 }} animate={inView ? { opacity: 1 } : {}} transition={{ duration: 0.4, delay: 0.8 + i * 0.15 }}>
              <span className='font-mono font-semibold' style={{ color: COMPETITOR_RED }}>
                {bar.before}
                {bar.unit}
              </span>
              <svg className='size-4' style={{ color: MUTED_GRAY }} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
                <path d='M5 12h14M12 5l7 7-7 7' />
              </svg>
              <span className='font-mono font-bold' style={{ color: NOPING_GREEN }}>
                {bar.after}
                {bar.unit}
              </span>
            </motion.div>
          </motion.div>
        );
      })}
    </div>
  );
}
